import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import React from 'react';
interface SynchTripResultSummaryProps {
  importedRows: number;
  validRows: number;
  inValidRows: number;
}
const SynchTripResultSummary = (props: SynchTripResultSummaryProps) => {
  const { importedRows, validRows, inValidRows } = props;
  return (
    <div id="importsummary-wrapper" className="grid place-items-center mt-20">
      <RMSvgIcon
        id="importsummary-icon"
        name="ImportSummary"
        fill="#4CAF50"
        width={80}
        height={80}
      ></RMSvgIcon>
      <label id="importsummary-label-text" style={{ fontSize: 20 }}>
        Data Imported Successfully
      </label>
      <div id="importsummary-data-wrapper" className="flex flex-row w-1/2 space-x-4">
        <div id="importsummary-data-importeddata" className="h-42 w-1/2 bg-gray-200">
          <div
            id="importsummary-data-importeddata-section"
            className="grid place-items-center mt-10 text-xl"
          >
            <div id="importsummary-data-importeddata-title">Imported Data</div>
            <div id="importsummary-data-importeddata-rows">{importedRows}</div>
          </div>
        </div>
        <div
          id="importsummary-data-status-wrapper"
          className="flex flex-column w-1/2 space-y-2"
        >
          <div id="importsummary-data-status-validdata" className="h-20 bg-gray-200">
            <div
              id="importsummary-data-status-validdata-section"
              className="grid place-items-center mt-3 text-xl"
            >
              <div id="importsummary-data-status-validdata-text">
                Valid Data{' '}
                <label
                  id="importsummary-data-status-validdata-label"
                  className="text-green-600"
                >
                  {validRows}
                </label>
              </div>
            </div>
          </div>
          <div id="importsummary-data-status-invaliddata" className="h-20 bg-gray-200">
            <div
              id="importsummary-data-status-invaliddata-section"
              className="grid place-items-center mt-3 text-xl"
            >
              <div id="importsummary-data-status-invaliddata-text">
                Invalid Data{' '}
                <label
                  id="importsummary-data-status-invaliddata-label"
                  className="text-red-600"
                >
                  {inValidRows}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SynchTripResultSummary;
